import React from "react";

function initials(name = "") {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() || "")
    .join("") || "?";
}

/**
 * Circular avatar that shows the user's photo (if `src` provided) or a
 * gradient-filled initials badge. Used in sidebar footer + top header.
 */
export default function UserAvatar({ name, src, size = "md", className = "" }) {
  const dims = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
  }[size] || "w-10 h-10 text-sm";

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={`${dims} rounded-full object-cover ring-2 ring-white shadow-sm ${className}`}
      />
    );
  }

  return (
    <div
      className={`${dims} rounded-full bg-gradient-to-br from-[#3B82F6] to-[#1D4ED8] text-white font-heading font-semibold flex items-center justify-center ring-2 ring-white shadow-sm ${className}`}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
